const ids = {
	axial: 'CT_AXIAL',
	sagittal: 'CT_SAGITTAL',
	coronal: 'CT_CORONAL',
	volume: 'VOLUME',
};

export default ids;
